// import Actions from './actions/PluginSetup'
import TableListGroupDataViewer from "./TableListGroupDataViewer.js";
export default {
  install(molten) {
    // Actions.install( molten )
    molten.addPlugin('DataViewer', TableListGroupDataViewer);
  }
};